import type { Participant } from './participant.types';

const PARTICIPANT_STORAGE_KEY = 'execution-hub:participant';

export function saveParticipantSession(participant: Participant) {
  localStorage.setItem(PARTICIPANT_STORAGE_KEY, JSON.stringify(participant));
}

export function getParticipantSession(): Participant | null {
  const raw = localStorage.getItem(PARTICIPANT_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as Participant;
  } catch {
    localStorage.removeItem(PARTICIPANT_STORAGE_KEY);
    return null;
  }
}

export function clearParticipantSession() {
  localStorage.removeItem(PARTICIPANT_STORAGE_KEY);
}
